import Skeleton from "react-loading-skeleton";
import Dropdowns from "../../../../../components/Dropdowns/Dropdowns";
import {
  DropdownsContext,
  DropdownsProvider,
} from "../../../../../contexts/DropdownsContext";
import { useContext, useEffect, useRef, useState } from "react";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import { dropdownConfig } from "../../../../../services/dropdownsConfigService";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import {
  createPartRequestAndIssue,
  getEmployeesByLocation,
  issuePartsFromPartRequest,
} from "../../../Services/partRequestService";
import "./FastPartRequest.css";
import Input from "../../../../../components/Inputs/Input";
import BasicDatePicker from "../../../../../components/Datepicker/Datepicker";
import { Radios } from "../../../../../components/RadioGroup/Radios";
import { ResultsNotFound } from "../../../../../components/ResultsNotFound/ResultsNotFound";
import { Tooltip } from "@mui/material";
import {
  getPartRequestInfoByPart,
  getTaskCardsFindingsByPart,
} from "../../../Services/InventoryConfigurationService";
import { Sorting } from "../../../../../components/Lists/Sorting";
import { DialogContext } from "../../../../../contexts/DialogContext";
import { GenericPartRequestModal } from "../../PartRequest/PartRequestModals/GenericPartRequestModal";
import { getUserCompanyId } from "../../../../../services/authService";
import { batch } from "react-redux";

const IssuePartActions = ({ partRequestSelected, part, saveSuccess }) => {
  const [rackDrop, setRackDrop] = useState(null);
  const [employeeDrop, setEmployeeDrop] = useState(null);
  const [displayDropdown, setDisplayDropdown] = useState(false);
  const [forceDependency, setForceDependency] = useState([]);
  const [dataEmployeeDrop, setDataEmployeeDrop] = useState([]);
  const [employeeSelected, setEmployeeSelected] = useState(null);
  const [cantToIssue, setCantToIssue] = useState(
    part?.orginalInfo?.quantity ?? 0
  );
  const { openDialog, closeDialog } = useContext(DialogContext);
  const hideFieldsWhenDisabled = new Set(["Rack"]);
  const [issueDetailToSelect, setIssueDetailToSelect] = useState(2);
  const dropdownIds = [79];
  const {
    dropdownsData,
    setDropdownsData,
    dropdownDefaultOptions,
    setDropdownIds,
  } = useContext(DropdownsContext);

  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  const getEmployeesDropdownConfig = async () => {
    let dropdownId = 85;
    const request = await dropdownConfig(dropdownId);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      const data = await getEmployeesByLocation(26);
      setDataEmployeeDrop(data.data.load);
      setEmployeeDrop(request.data.load);
    }
  };

  useEffect(() => {
    if (partRequestSelected) {
      getEmployeesDropdownConfig();
      setDropdownIds(dropdownIds);
      setForceDependency([
        {
          id: 25,
          parentSqlstatementColumnName: "id",
          childDropdownId: 79,
          childSqlstatementColumnName: "site_id",
          childSqlstatementParameterName: "siteId",
          contextId: 1,
          value: [partRequestSelected.orginalInfo.site_id],
        },
      ]);
    }
  }, [partRequestSelected]);

  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) setDisplayDropdown(true);
  }, [dropdownsData]);
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };

  const getEmployeeSelection = (selectedValues) => {
    setEmployeeSelected(selectedValues.id);
    setRackDrop(null);
  };
  const getRackSelection = (selectedValues) => {
    setRackDrop(selectedValues.id);
    setEmployeeSelected(null);
  };
  const getBestDetailId = (detailsIds, partInfo) => {
    const match = detailsIds.find(
      (detail) => detail.internalBatch === partInfo.internal_batch
    );
    if (match) return match;

    return detailsIds.reduce((min, current) => {
      return current.cantRquest < min.cantRquest ? current : min;
    }, detailsIds[0]);
  };

  const askForConfirmation = () => {
    if (partRequestSelected.status == "Not Applicable") {
      openDialog({
        component: GenericPartRequestModal,
        props: {
          title: "Warning",
          description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.`,
          close: closeDialog,
          maxWidth: "30vw",
          textArea: true,
          confirmLabel: "Send to Engineering",
          okAction: () => issueParts(),
        },
      });
    } else {
      issueParts();
    }
  };
  const issueParts = async () => {
    if (!partRequestSelected) return;
    let partRequestInfo = partRequestSelected.orginalInfo;
    let partInfo = part.orginalInfo;

    const payLoad = {
      companyId: parseInt(getUserCompanyId()),
      locationId: partRequestInfo.location_id,
      siteId: partRequestInfo.site_id,
      aircraftId: partRequestInfo.aircraft_id,
      workPackageId: partRequestInfo.work_package_id,
      dateRequestCreated: new Date(),
      dateRequestRequired: new Date(),
      customerId: partRequestInfo.customer_id,
      description: "",
      status: "Posted",
      version: 0,
      partRequestDetailParts: [
        {
          taskCardId: partRequestInfo.task_card_id,
          findingId: null,
          quantity: cantToIssue,
          uomId: partInfo.uom_id,
          companyId: parseInt(getUserCompanyId()),
          partId: partInfo.part_id,
          serializedPartId: partInfo.serialized_part,
          locationId: partInfo.location_id,
          batchId: partInfo.internal_batch,
          siteId: partInfo.site_id,
          rackId: partInfo.rack_id,
          shelfId: partInfo.shelf_id,
          binId: partInfo.bin_id,
        },
      ],
      issuePartsDTO: {
        rackId: issueDetailToSelect == 1 ? rackDrop : null,
        employeeId: issueDetailToSelect == 2 ? employeeSelected : null,
        companyId: partInfo.company_id,
        details: [
          {
            serializedPartId: partInfo.serialized_part ?? null,
            siteId: partInfo.site_id,
            rackId: partInfo.rack_id,
            binId: partInfo.bin_id,
            shelfId: partInfo.shelf_id,
            locationId: partInfo.location_id,
            quantityToIssue: cantToIssue,
            partId: partInfo.part_id,
            companyId: partInfo.company_id,
            uomId: partInfo.uom_id,
            internalBatch: partInfo.internal_batch,
          },
        ],
      },
    };
    createPartRequestAndIssue(payLoad)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          successMsg("Parts Were issued successfully");
          saveSuccess();
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {});
  };
  const handleQTYToIssueChange = (e) => {
    const newQTY = e.target.value;
    setCantToIssue(newQTY);
  };
  return (
    <div style={{ display: "flex", gap: "0.5rem" }}>
      {partRequestSelected && (
        <>
          <div className="issue-detail-cant">
            <b>QTY to issue</b>
            <Input
              name="quantity_issue"
              disableAutocomplete={true}
              placeholder={"Qty to Issue"}
              label={""}
              disabled={false}
              limit={part?.orginalInfo?.quantity}
              isNumeric={true}
              onChange={(e) => handleQTYToIssueChange(e)}
              value={cantToIssue}
            />
          </div>
          <div className="issue-detail">
            <Radios
              name="miGrupo"
              items={[
                { label: "Issue to Employee", value: 2 },
                { label: "Issue to Rack", value: 1 },
              ]}
              value={issueDetailToSelect}
              onChange={(val) => setIssueDetailToSelect(val)}
            />
          </div>
          <div style={{ width: "13vw" }}>
            {issueDetailToSelect == 1 ? (
              displayDropdown ? (
                <Dropdowns
                  context={{
                    dropdownsData,
                    setDropdownsData,
                    setDropdownIds,
                    dropdownDefaultOptions,
                  }}
                  required={true}
                  hideLabel={true}
                  placeholder={true}
                  forceDependency={forceDependency}
                  updateDropdown={updateDropdown}
                  resetDropdownsReload={resetDropdownsReload}
                  hideWhenDisabled={hideFieldsWhenDisabled.has("rackId")}
                  key={79}
                  onOptionSelect={(value, data) =>
                    getRackSelection(value, "rackId", data)
                  }
                  showPagination={false}
                  data={dropdownsData.find((e) => e.id === 79)}
                ></Dropdowns>
              ) : (
                <Skeleton height="2rem" width="80%" />
              ) //sites
            ) : employeeDrop ? (
              <Dropdowns
                onOptionSelect={getEmployeeSelection}
                updateDropdown={updateDropdown}
                resetDropdownsReload={resetDropdownsReload}
                staticDataColumnPreselection={"id"}
                isStatic={true}
                hideLabel={true}
                placeholder={true}
                staticData={dataEmployeeDrop}
                data={employeeDrop}
                required={true}
              ></Dropdowns>
            ) : (
              <Skeleton height="2rem" width="100%" />
            )}
          </div>
        </>
      )}
      <button
        className={`part-request-button-issue ${
          !partRequestSelected ||
          (issueDetailToSelect == 1 && !rackDrop) ||
          (issueDetailToSelect == 2) & !employeeSelected
            ? "disabled"
            : ""
        }`}
        onClick={() => askForConfirmation()}
      >
        <div className="left-side">
          <i className="icon-issue"></i>
          <p>Part Issue </p>{" "}
        </div>
      </button>
    </div>
  );
};
const SearchBarContainer = ({ onSearch }) => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  const didMount = useRef(false);
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 1000); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    onSearch(debouncedValue);
  }, [debouncedValue]);
  return <input placeholder="Search" onChange={handleChange} />;
};
const FastPartRequest = ({ part, saveSuccess }) => {
  const [loadingParts, setLoadingParts] = useState(true);
  const listRef = useRef(null);
  const [maxPages, setMaxPages] = useState(null);
  const didMount = useRef(false);
  const loadListFirst = useRef(false);
  const [page, setPage] = useState(0);
  const [sortingOrder, setSortingOrder] = useState("status");
  const [search, setSearch] = useState("");
  const [formattedItems, setFormattedItems] = useState([]);
  const [partRequestSelected, setPartRequestSelected] = useState(null);
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const pageSize = 10;
  const [modeView, setModeView] = useState(1);
  const itemMapper = (item) => {
    return {
      id: item.id,
      TCNumber: item.task_card_number,
      status: item.status,
      WP: item.work_packages_name || "--",
      Company: item.company_name || "--",
      Location: item.location_name || "--",
      Site: item.site_name || "--",
      Aircraft: item.tail_number || "--",
      QTY: item.quantity || "--",
      orginalInfo: item,
    };
  };
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
  }, [formattedItems]);
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      if (!setLoadingParts) requestNextPage();
    }
  };
  const requestNextPage = () => {
    setPage((prev) => Math.min(prev + 1, maxPages - 1));
  };
  const getSortingOrder = (order) => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    setSortingOrder(order);
  };

  useEffect(() => {
    setLoadingParts(true);
    getTaskCardsFindingsByPart(
      page,
      pageSize,
      search,
      sortingOrder,
      part.partId
    )
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let data = response.data.load;
          setLoadingParts(false);
          if (!data || data.length === 0) return [];

          setFormattedItems(
            data?.map((item, index) => {
              let mappedItem = itemMapper?.(item) ?? item;
              return { ...mappedItem, id: index };
            }) ?? []
          );
        }
      })
      .catch((error) => setLoadingParts(false));
  }, [page, search, sortingOrder]);

  const onChangeRadio = (value) => {
    const selectedItem = formattedItems.find(
      (item) => item.id == Number(value)
    );
    setPartRequestSelected(selectedItem);
  };
  return (
    <>
      <div className="inventory-dialog-body-actions">
        <div className="inventory-dialog-body-actions">
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
              width: "35%",
            }}
          >
            <h2>Part Request</h2>
            <div className="search-bar-input">
              <SearchBarContainer onSearch={setSearch} />
              <i className="icon-search"></i>
            </div>
          </div>
          <DropdownsProvider>
            <IssuePartActions
              part={part}
              partRequestSelected={partRequestSelected}
              saveSuccess={saveSuccess}
            ></IssuePartActions>
          </DropdownsProvider>
        </div>
        <div className="information-header">
          <i className="icon-info"></i>
          <p>
            You can issue applicable or not applicable parts. If you issue a not
            applicable part, an override will be applied to continue the
            process.
          </p>
        </div>
        <div className="sorting-header new-list">
          <div className="sorting-free-slot"> </div>
          <Sorting
            onOrderChange={getSortingOrder}
            ignoreProperties={true}
        showHeaderOrder={true}
            properties={{
              status: "Applicability",
              task_card_number: "TC/FDN",
              work_packages_name: "WP",
              company_name: "Company",
              location_name: "Location",
              site_name: "Site",
              tail_number: "Aircraft",
            }}
          ></Sorting>
        </div>
      </div>
      <div className="inventory-dialog-body">
        <div
          className="inventory-list new-part-req-list"
          ref={listRef}
          onScroll={handleScroll}
        >
          {loadingParts ? (
            // Mostrar esqueletos mientras carga
            Array.from({ length: 7 }).map((_, idx) => (
              <div key={idx} className="item-container-skeleton">
                <Skeleton
                  style={{ borderRadius: "10px" }}
                  height="1.68rem"
                  width={40}
                />
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="80%" />
                </div>
                <Skeleton height={30} width="7rem" />
              </div>
            ))
          ) : formattedItems.length === 0 ? (
            <ResultsNotFound />
          ) : (
            <Radios
              items={formattedItems.map((item, idx) => ({
                value: item.id,
                item, // lo pasamos tal cual para usarlo luego
              }))}
              name="myRadio"
              value={partRequestSelected?.id ?? null}
              onChange={(value) => onChangeRadio(value)}
              direction="column"
              customRender={(radioItem, isSelected) => (
                <div className="item-prn-radio-container">
                  <div
                    className={`status-tag ${
                      radioItem.item.status == "Applicable" ? "info" : ""
                    }`}
                  >
                    {radioItem.item.status}
                  </div>
                  {["TCNumber", "WP", "Company", "Location", "Site", "Aircraft"].map((label) => (
                    <div className="property" key={label}>
                      {label == "TCNumber" && (
                        <i className="icon-task_icon_partRequest"></i>
                      )}
                      <Tooltip
                        title={
                          tooltips[`${radioItem.item.id}-${label}`]
                            ? radioItem.item[label]
                            : ""
                        }
                        arrow
                      >
                        <p
                          className="light-font"
                          ref={(el) => {
                            if (el) {
                              propertyRefs.current[
                                `${radioItem.item.id}-${label}`
                              ] = el;
                            }
                          }}
                        >
                          {radioItem.item[label]}
                        </p>
                      </Tooltip>
                    </div>
                  ))}
                </div>
              )}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default FastPartRequest;
